"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroXSwapStep = void 0;
const token_1 = require("../../../utils/token");
const step_1 = require("../../step");
class ZeroXSwapStep extends step_1.Step {
    constructor(quote, sellERC20Info) {
        super();
        this.config = {
            name: '0x Exchange Swap',
            description: 'Swaps two ERC20 tokens using 0x Exchange DEX Aggregator.',
            hasNonDeterministicOutput: true,
        };
        this.quote = quote;
        this.sellERC20Info = sellERC20Info;
    }
    async getStepOutput(input) {
        const { buyERC20Amount, minimumBuyAmount, crossContractCall, sellTokenValue, spender, } = this.quote;
        const { erc20Amounts } = input;
        const sellERC20Amount = BigInt(sellTokenValue);
        const { erc20AmountForStep, unusedERC20Amounts } = this.getValidInputERC20Amount(erc20Amounts, erc20Amount => (0, token_1.compareERC20Info)(erc20Amount, this.sellERC20Info) &&
            (0, token_1.isApprovedForSpender)(erc20Amount, spender), sellERC20Amount);
        const sellERC20AmountRecipient = {
            ...this.sellERC20Info,
            amount: erc20AmountForStep.expectedBalance,
            recipient: '0x Exchange',
        };
        const outputBuyERC20Amount = {
            tokenAddress: buyERC20Amount.tokenAddress,
            decimals: buyERC20Amount.decimals,
            isBaseToken: buyERC20Amount.isBaseToken,
            expectedBalance: buyERC20Amount.amount,
            minBalance: minimumBuyAmount,
            approvedSpender: undefined,
        };
        return {
            crossContractCalls: [crossContractCall],
            spentERC20Amounts: [sellERC20AmountRecipient],
            outputERC20Amounts: [outputBuyERC20Amount, ...unusedERC20Amounts],
            outputNFTs: input.nfts,
        };
    }
}
exports.ZeroXSwapStep = ZeroXSwapStep;
